module.exports = __webpack_public_path__ + "static/media/banner_en_US.ca383eb3.png";